import type {
  ShortlistRound,
  ShortlistEntry,
  StartRoundBody,
  PatchAction,
  RunPromoterResponse,
  Depositor,
} from 'views/ProjectsV2/Shortlist/types'

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v2`

const unwrap = async <T>(res: Response, method: string): Promise<T> => {
  if (!res.ok) {
    const text = await res.text()
    throw new Error(`${method} failed: ${res.status} ${text}`)
  }
  const body = await res.json()
  return (body?.data ?? body) as T
}

export const listShortlistRounds = async (
  dealId: string,
): Promise<ShortlistRound[]> => {
  const res = await fetch(`${BASE}/admin/deals/${dealId}/shortlist/rounds`, {
    method: 'GET',
    credentials: 'include',
  })
  return unwrap<ShortlistRound[]>(res, 'GET')
}

export const startShortlistRound = async (
  dealId: string,
  body: StartRoundBody,
): Promise<ShortlistRound> => {
  const res = await fetch(`${BASE}/admin/deals/${dealId}/shortlist/rounds`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  return unwrap<ShortlistRound>(res, 'POST')
}

export const closeShortlistRound = async (
  dealId: string,
  roundId: number,
): Promise<ShortlistRound> => {
  const res = await fetch(
    `${BASE}/admin/deals/${dealId}/shortlist/rounds/${roundId}/close`,
    {
      method: 'POST',
      credentials: 'include',
    },
  )
  return unwrap<ShortlistRound>(res, 'POST')
}

export const listShortlistEntries = async (
  dealId: string,
  roundId: number,
): Promise<ShortlistEntry[]> => {
  const res = await fetch(
    `${BASE}/admin/deals/${dealId}/shortlist/rounds/${roundId}/entries`,
    { method: 'GET', credentials: 'include' },
  )
  return unwrap<ShortlistEntry[]>(res, 'GET')
}

export const patchShortlistEntries = async (
  dealId: string,
  roundId: number,
  actions: PatchAction[],
): Promise<ShortlistEntry[]> => {
  const res = await fetch(
    `${BASE}/admin/deals/${dealId}/shortlist/rounds/${roundId}/entries`,
    {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ actions }),
    },
  )
  return unwrap<ShortlistEntry[]>(res, 'PATCH')
}

export const runShortlistPromoter = async (): Promise<RunPromoterResponse> => {
  const res = await fetch(`${BASE}/admin/shortlist/promoter/run`, {
    method: 'POST',
    credentials: 'include',
  })
  return unwrap<RunPromoterResponse>(res, 'POST')
}

export const listDealDepositors = async (
  dealId: string,
): Promise<Depositor[]> => {
  const res = await fetch(`${BASE}/admin/deals/${dealId}/depositors`, {
    method: 'GET',
    credentials: 'include',
  })
  return unwrap<Depositor[]>(res, 'GET')
}
